<template>
  <v-app>
    <router-view></router-view>
  </v-app>
</template>

<script>
require("vue-image-lightbox/dist/vue-image-lightbox.min.css");
import getCurrentNav from "@/methods/utilities.vue";
import { mapGetters } from "vuex";
export default {
  name: "App",
  mixins: [getCurrentNav],
  data() {
    return {
      updated_nav: [],
    };
  },

  mounted() {
    this.authCheck();
  },

  methods: {
    authCheck() {
      const isLoggedIn = localStorage.getItem("token") ? true : false;
      this.updated_nav = JSON.parse(localStorage.getItem("updatedNav"));
      if (!isLoggedIn) {
        this.$router.push({ path: `/login` });
      } else {
        if (
          window.location.pathname === "/login" ||
          window.location.pathname === "/"
        ) {
          this.getCurrentNav(this.updated_nav);
        } else {
          var arrayLength =
            this.updated_nav[0] &&
            this.updated_nav[0]._children &&
            this.updated_nav[0]._children.length;
          let navParentLinks = [];
          let navChildLinks = [];
          for (var i = 0; i < arrayLength; i++) {
            let separatedNav = this.updated_nav[0]._children[i];
            if (separatedNav.to) {
              navParentLinks.push(separatedNav.to);
            } else {
              separatedNav.items.forEach((item) => {
                navChildLinks.push(item.to);
              });
            }
          }
          this.totalNavLinks = [...navParentLinks, ...navChildLinks];

          if (this.totalNavLinks.includes("/blogsListing")) {
            this.totalNavLinks = [
              ...this.totalNavLinks,
              "/createBlog",
              `${localStorage.getItem("currentPathName")}`,
            ];
          } else {
            return;
          }
          if (this.totalNavLinks.includes("/newsListing")) {
            this.totalNavLinks = [
              ...this.totalNavLinks,
              "/createNews",
              `${localStorage.getItem("currentPathName")}`,
            ];
          } else {
            return;
          }

          if (!this.totalNavLinks.includes(window.location.pathname)) {
            this.$router.push({ name: `pageNotFound` });
          } else {
            console.log("outside");
          }
        }
      }
    },
  },
};
</script>

<style lang="scss">
// Import Main styles for this application
@import "assets/scss/style";
</style>
